import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export interface BulkDownloadTask {
  mediaIds: number[];
  startedAt: number;
}

export const useBulkDownloadStore = defineStore('bulkDownload', () => {
  const activeTasks = ref<Record<string, BulkDownloadTask>>({});

  const hasActiveTask = computed(() => Object.keys(activeTasks.value).length > 0);

  function isActiveTask(taskId: string): boolean {
    return Object.prototype.hasOwnProperty.call(activeTasks.value, taskId);
  }

  function startTask(taskId: string, mediaIds: number[]) {
    activeTasks.value = {
      ...activeTasks.value,
      [taskId]: { mediaIds: [...mediaIds], startedAt: Date.now() },
    };
  }

  function clearTask(taskId: string): boolean {
    if (!isActiveTask(taskId)) return false;
    const next = { ...activeTasks.value };
    delete next[taskId];
    activeTasks.value = next;
    return true;
  }

  return {
    activeTasks,
    hasActiveTask,
    isActiveTask,
    startTask,
    clearTask,
  };
});
